import * as util from './markup-utils';

export const createSmallRegion = (region, viewport) => {
  let tile;
  let urlBuilder;
  let boundingBox;
  let isRegionHidden = true;
  let isDirty = false;
  let viewportZoom;
  let viewportState = viewport.getVPView();

  const show = () => {
    if (!tile.src || isDirty) {
      const zoom = 1;
      tile.src = urlBuilder.region(0, 0, boundingBox.w, boundingBox.h, zoom, util.MARKUP_QUALITY);
      isDirty = false;
    }
    tile.style.display = '';
  };

  const hide = () => {
    tile.style.display = 'none';
  };

  const self = {
    render () {
      urlBuilder = util.createUrlBuilder(viewport, region.MarkupImageId);
      boundingBox = region.getMarkupInfo().boundingBox;

      tile = document.createElement('img');
      tile.className = 'us-markup-tile';
      hide();
    },

    paint () {
      if (!isRegionHidden && util.isVisible(region, viewport)) {
        // First check if zoom has changed; if so we have to do a little extra work.
        if (viewportZoom !== viewportState.zoom) {
          viewportZoom = viewportState.zoom;
          tile.style.width = `${parseInt(boundingBox.w / viewportZoom, 10)}px`;
          tile.style.height = `${parseInt(boundingBox.h / viewportZoom, 10)}px`;
          tile.style.left = `${boundingBox.left / viewportZoom}px`;
          tile.style.top = `${boundingBox.top / viewportZoom}px`;
        }

        show();
      } else {
        hide();
      }
    },

    show () {
      isRegionHidden = false;
      this.paint();
    },

    hide () {
      isRegionHidden = true;
      this.paint();
    },

    remove () {
      return tile.remove();
    },

    markAsDirty () {
      isDirty = true;
      urlBuilder.setImageId(region.MarkupImageId);
      self.paint();
    },

    get fragment () {
      return tile;
    }
  };
  return self;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-analysis/markup/small-markup-region.js